module.exports = __webpack_public_path__ + "static/media/hex-20.f83fd86c.svg";